/* eslint-disable camelcase */
import common_es from './es/common.json';

export default {
  es: {
    common: common_es,
  },
};
